// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html {\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow-y: auto !important;\n  overscroll-behavior: contain;\n}\nbody {\n  font-family: Roboto, Arial, Helvetica, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--v-background-base);\n  height: auto;\n  padding: 0;\n  margin: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
